
/**
 * @nullable
 */
export type GetNotifications200NotificationsItemData = {[key: string]: unknown} | null;
